import { BlockTypes } from 'enum/block-type.enum'
import { createAction } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'
import { IQuestionLikertModel } from 'models/questionLikert.model'
import { IOpenEndedModel } from 'models/questionOpenEnded.model'

export const SET_QUESTION_LOADING = 'SET_QUESTION_LOADING'
export const GET_QUESTIONS_LIST = 'GET_QUESTIONS_LIST'
export const GET_QUESTION_LIST_SUCCESS = 'GET_QUESTION_LIST_SUCCESS'
export const GET_QUESTION = 'GET_QUESTION'
export const GET_QUESTION_SUCCESS = 'GET_QUESTION_SUCCESS'
export const QUESTION_LIKERT_CREATE = 'QUESTION_LIKERT_CREATE'
export const QUESTION_OPENENDED_CREATE = 'QUESTION_OPENENDED_CREATE'
export const QUESTION_LIKERT_CREATE_SUCCESS = 'QUESTION_LIKERT_CREATE_SUCCESS'
export const QUESTION_OPENENDED_CREATE_SUCCESS =
  'QUESTION_OPENENDED_CREATE_SUCCESS'
export const QUESTION_LIKERT_EDIT = 'QUESTION_LIKERT_EDIT'
export const QUESTION_OPENENDED_EDIT = 'QUESTION_OPENENDED_EDIT'
export const QUESTION_LIKERT_DESTROY = 'QUESTION_LIKERT_DESTROY'
export const QUESTION_OPENENDED_DESTROY = 'QUESTION_OPENENDED_DESTROY'

export const Actions = {
  questionsList: (instanceId: number) =>
    createAction(GET_QUESTIONS_LIST, instanceId),
  questionsListSuccess: (data: any) =>
    createAction(GET_QUESTION_LIST_SUCCESS, data),
  questionGet: (questionId: number, type: string) =>
    createAction(GET_QUESTION, { questionId, type }),
  questionGetSuccess: (data: any) => createAction(GET_QUESTION_SUCCESS, data),
  questionLikertCreate: (
    data: IQuestionLikertModel<
      BlockTypes.BlockSurvey | BlockTypes.BlockEvaluation
    >
  ) => createAction(QUESTION_LIKERT_CREATE, data),
  questionOpenEndedCreate: (data: any) =>
    createAction(QUESTION_OPENENDED_CREATE, data),
  questionLikertSuccess: (
    data: IQuestionLikertModel<
      BlockTypes.BlockSurvey | BlockTypes.BlockEvaluation
    >
  ) => createAction(QUESTION_LIKERT_CREATE_SUCCESS, data),
  questionOpenEndedCreateSuccess: (data: any) =>
    createAction(QUESTION_OPENENDED_CREATE_SUCCESS, data),
  questionLikertEdit: (
    likertId: number,
    instanceId: number,
    data: IQuestionLikertModel<
      BlockTypes.BlockSurvey | BlockTypes.BlockEvaluation
    >
  ) => createAction(QUESTION_LIKERT_EDIT, { likertId, instanceId, data }),
  questionOpenEndedEdit: (
    openEndedId: number,
    instanceId: number,
    data: IOpenEndedModel
  ) => createAction(QUESTION_LIKERT_EDIT, { openEndedId, instanceId, data }),
  questionLikertDestroy: (questionId: number) =>
    createAction(QUESTION_LIKERT_DESTROY, questionId),
  questionOpenEndedDestroy: (questionId: number) =>
    createAction(QUESTION_LIKERT_DESTROY, questionId),
  setQuestionLoading: (loading: boolean) =>
    createAction(SET_QUESTION_LOADING, loading),
}

export type Actions = ActionsUnion<typeof Actions>
